import Vue from 'vue';
import { toast, SuspendMenu, Button } from '@mx/vix';
import './directive';

[SuspendMenu, Button].map((c) => Vue.use(c));

Vue.prototype.$toast = toast;

export * from './ajax';
export * from './env';
export * from './api';
export * from './bridge';
export * from './monitor';
export * from './constant';
export * from './util';
